import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled, { css } from 'styled-components';
import { marginAttributes, paddingAttributes } from '../../system/attributes';
import { makePropList, getPropsBlocker } from '../../utils';
import { transitionDurationInSec } from '../../constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = makePropList(['enableBottomSeparator', 'secondary', 'tertiary', 'expanded', 'enableEffects']);

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var theme = _ref.theme,
      enableBottomSeparator = _ref.enableBottomSeparator,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      expanded = _ref.expanded,
      enableEffects = _ref.enableEffects;
  var Menu = theme.componentOverrides.Menu;
  var result = Menu.Root.base;

  if (enableBottomSeparator) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            border-bottom-width: 1px;\n            border-bottom-style: solid;\n            ", "\n        "])), result, Menu.Root.bottomSeparator);
  }

  if (secondary) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, Menu.Root.secondary);
  } else if (tertiary) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, Menu.Root.tertiary);
  }

  if (expanded !== undefined) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            overflow-y: hidden;\n            height: ", ";\n        "])), result, expanded ? 'auto' : '0');

    if (enableEffects) {
      result = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                ", ";\n                opacity: ", ";\n                transform: translateX(", ");\n                transition: transform ", "s ease-in-out,\n                    opacity ", "s ease;\n            "])), result, expanded ? '1' : '0', expanded ? '0' : '-5px', transitionDurationInSec, transitionDurationInSec);
    }
  }

  return result;
};

export var MenuRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n\n    ", "\n    ", ";\n    ", "\n    ", "\n"])), getRootDynamicStyle, getComponentOverride('Menu'), marginAttributes, paddingAttributes);